import React from 'react';
import Icon from './Icon';

/**
 * Tabs — accessible tablist. variant: underline | pill
 * items: [{ id, label, icon?, count? }]
 */
export default function Tabs({ items, value, onChange, variant = 'underline', className = '', ariaLabel }) {
  const idx = Math.max(0, items.findIndex((i) => i.id === value));
  const onKeyDown = (e) => {
    if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
    e.preventDefault();
    const next = e.key === 'ArrowRight' ? (idx + 1) % items.length : (idx - 1 + items.length) % items.length;
    onChange(items[next].id);
  };
  return (
    <div role="tablist" aria-label={ariaLabel} className={`tabs tabs--${variant}${className ? ` ${className}` : ''}`} onKeyDown={onKeyDown}>
      {items.map((it) => {
        const active = it.id === value;
        return (
          <button
            key={it.id}
            role="tab"
            type="button"
            aria-selected={active}
            tabIndex={active ? 0 : -1}
            className={`tabs__item${active ? ' is-active' : ''}`}
            onClick={() => onChange(it.id)}
          >
            {it.icon && <Icon name={it.icon} size={16} />}
            <span>{it.label}</span>
            {it.count != null && <span className="tabs__count">{it.count}</span>}
          </button>
        );
      })}
    </div>
  );
}
